import { defineStore } from 'pinia';
import * as constants from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const useAppStore = defineStore('app', {
    id: 'app',

    state: () => ({
        isMobile: false,
        // Current configuration step.
        currentStep: 'loading',
        enabledSteps: [constants.STEP_SELECT_PROOF],
        personalization: '',
        keyboardOpen: false,
    }),

    getters: {
    },

    actions: {
        /**
         * Log an event.
         */
        log({
            level,
            message,
            style,
        }) {
            if (style) {
                // eslint-disable-next-line
                console.log(`%c${level}: ${message}`, style);
            } else {
                // eslint-disable-next-line
                console.log(`${level}: ${message}`);
            }
        },

        /**
         * Sets whether the app is in mobile mode.
         */
        setIsMobile(isMobile) {
            this.isMobile = isMobile;
        },

        /**
         * Sets current application step.
         */
        setCurrentStep(step) {
            this.currentStep = step;
            this.enableStep(step);
        },

        /**
         * Explicitly enables a step.
         */
        enableStep(step) {
            if (!this.enabledSteps.includes(step)) {
                this.enabledSteps.push(step);
            }
        },

        /**
         * Sets the selected option in a group.
         */
        setSelectedOption(groupName, option) {
            this.selectedOptions[groupName] = option;
        },

        /**
         * Sets the personalization text.
         */
        setPersonalization(signature) {
            this.personalization = signature;
        },

        /**
         * Determines whether a step is enabled.
         */
        isEnabledStep(groupName) {
            return this.enabledSteps.some((stepName) => {
                if (stepName.includes(groupName)) {
                    return true;
                }

                return false;
            });
        },

        /**
         * Determines the next step.
         */
        loadNextStep(groupName) {
            let nextStep = '';
            let isPreviousStep = false;

            if (this.currentStep === constants.STEP_SELECT_WHISKEY) {
                nextStep = constants.STEP_SELECT_SPIRE;
            } else if (this.currentStep === constants.STEP_SELECT_SPIRE) {
                isPreviousStep = groupName === 'Whiskey';
                nextStep = constants.STEP_SELECT_INFUSION;
            } else if (this.currentStep === constants.STEP_SELECT_INFUSION) {
                isPreviousStep = groupName === 'Spire' || groupName === 'Whiskey';
                nextStep = constants.STEP_PERSONALIZE;
            }

            if (!isPreviousStep) {
                this.setCurrentStep(nextStep);
            }
        },

        /**
         * Determines the previous step.
         */
        loadPreviousStep() {
            let previousStep = '';

            if (this.currentStep === constants.STEP_SELECT_SPIRE) {
                previousStep = constants.STEP_SELECT_WHISKEY;
            } else if (this.currentStep === constants.STEP_SELECT_INFUSION) {
                previousStep = constants.STEP_SELECT_SPIRE;
            } else if (this.currentStep === constants.STEP_PERSONALIZE) {
                previousStep = constants.STEP_SELECT_INFUSION;
            }

            this.setCurrentStep(previousStep);
        },

        /**
         * Sets current step description.
         */
        resetCustomization() {
            this.enabledSteps = [constants.STEP_SELECT_PROOF];

            this.personalization = '';

            this.setCurrentStep(constants.STEP_SELECT_WHISKEY);
        },

        getArticle(string) {
            const vowelRegex = '^[aieouAIEOU].*';
            const matched = string.match(vowelRegex);

            return matched ? 'an' : 'a';
        },

        /**
         * Used to prevent elements from overlapping inputs when the keyboard is open on mobile.
         */
        toggleKeyboard(toggle) {
            this.keyboardOpen = toggle;
        },
    },
});
